import { useEffect, useState, FC } from 'react';
import Error500 from '../../components/error500/error500';
import GenericLoader from '../../survey-tool/components/generic-loader';
import { signInOrConnectFacebook } from '../fb-api';

export interface FacebookCodeProps {
  code: string;
}

export const FacebookCode: FC<FacebookCodeProps> = ({ code }) => {
  const appRefresh = () => {
    window.location.href = '/';
  };
  const [err, setErr] = useState<Error | null>(null);

  useEffect(() => {
    if (code) {
      signInOrConnectFacebook({ code }).then(appRefresh).catch(setErr);
    } else {
      appRefresh();
    }
  }, [code]);

  if (err) {
    return <Error500 title={err.message} />;
  }
  return <GenericLoader />;
};
